import { PayloadAction } from '@reduxjs/toolkit';

import { StationsState } from '../../types';

export const setStationsDisplay = (state: StationsState, action: PayloadAction<StationsState['display']>) => {
  state.display = action.payload;
};
